import {Component, Input} from '@angular/core';
import {TaskDto} from '../../../../../Models/Tasks/General/task.interface';

@Component({
  selector: 'app-task-data-block',
  templateUrl: './task-data-block.component.html',
  styleUrls: ['./task-data-block.component.scss'],
  standalone: false
})
export class TaskDataBlockComponent {
  @Input() task!: TaskDto;
}
